import SocialBarIcon from "@assets/social/icons.svg";
import ShareSocial, {
  SocialVariant,
} from "@components/Blocks/ShareSocial/ShareSocial";
import { useState } from "react";

type ShareSocialBarProps = {
  dateCreated: string;
  pageUrl: string;
  socialIconList: string[];
  title: string;
};

export function ShareSocialBar({
  dateCreated,
  pageUrl,
  socialIconList,
  title,
}: ShareSocialBarProps) {
  const [expandedSocialBar, setExpandedSocialBar] = useState(false);
  return (
    <div className="relative flex self-end">
      <button
        onClick={() => {
          setExpandedSocialBar((prev) => !prev);
        }}
      >
        <img src={SocialBarIcon} width={24} height={24} alt="share-buttons" />
      </button>
      <div
        className={`
          w-max flex p-2 bg-white-900 transition-all duration-300 rounded-[30px]
          absolute z-10 top-6 -right-1
          ${expandedSocialBar ? "opacity-100 scale-100" : "opacity-0 scale-95 pointer-events-none"}
        `}
      >
        <div className="flex self-end gap-2">
          {socialIconList.map((variant, index) => (
            <ShareSocial
              variant={variant as SocialVariant}
              pagePath={pageUrl}
              pageTitle={title}
              dateCreated={dateCreated}
              key={index}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
